import React from 'react';
// eslint-disable-next-line max-len
import { UniversalProductsCategory } from '@1po/1po-bff-fe-spec/generated/catalog/universal_products/response/GetUniversalProductsTreeResponse';
import { UNIVERSAL_PRODUCTS_LINK } from 'app/AppRouter';
import { CategoryCard } from 'pages/UniversalProductsPage/Menu/Menu.styled';
import { Box, Flex, Link, MarginBox, Text } from 'UI';

interface SubCategoriesProps {
  openCategoryId: string;
  level2Categories: UniversalProductsCategory[];
}

const hasChildCategories = (category: UniversalProductsCategory) => (category.childCategories?.length ?? 0) > 0;

const Level2Header = ({
  openCategoryId,
  level2Category,
}: {
  openCategoryId: string;
  level2Category: UniversalProductsCategory;
}) => {
  const isParent = hasChildCategories(level2Category);
  const title = (
    <Text type="lg" bold transform={'uppercase'} cursor={isParent ? undefined : 'pointer'} hoverUnderLine={!isParent}>
      {level2Category.name}
    </Text>
  );

  if (isParent) {
    return title;
  }

  return <Link to={`${UNIVERSAL_PRODUCTS_LINK}/${openCategoryId}/${level2Category.nodeId}`}>{title}</Link>;
};

const SubCategories = ({ openCategoryId, level2Categories }: SubCategoriesProps) => {
  return (
    <Box>
      <Flex wrap={'wrap'} gap={15}>
        {level2Categories.map((level2Category) => {
          return (
            <CategoryCard key={level2Category.nodeId}>
              <Flex direction={'column'} gap={8}>
                <Level2Header openCategoryId={openCategoryId} level2Category={level2Category} />
                {level2Category.childCategories?.map((level3Category) => {
                  return (
                    <MarginBox ml={5} key={level3Category.nodeId}>
                      <Link
                        to={`${UNIVERSAL_PRODUCTS_LINK}/${openCategoryId}/${level2Category.nodeId}/${level3Category.nodeId}`}
                      >
                        <Text type="base" cursor={'pointer'} hoverUnderLine>
                          {level3Category.name}
                        </Text>
                      </Link>
                    </MarginBox>
                  );
                })}
              </Flex>
            </CategoryCard>
          );
        })}
      </Flex>
    </Box>
  );
};

export default SubCategories;
